var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7946_5010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26V9C16 8.20435 16.3161 7.44129 16.8787 6.87868C17.4413 6.31607 18.2044 6 19 6C19.7956 6 20.5587 6.31607 21.1213 6.87868C21.6839 7.44129 22 8.20435 22 9V24",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 23V19C22 18.2044 22.3161 17.4413 22.8787 16.8787C23.4413 16.3161 24.2044 16 25 16C25.7956 16 26.5587 16.3161 27.1213 16.8787C27.6839 17.4413 28 18.2044 28 19V24",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21C28 20.2044 28.3161 19.4413 28.8787 18.8787C29.4413 18.3161 30.2044 18 31 18C31.7956 18 32.5587 18.3161 33.1213 18.8787C33.6839 19.4413 34 20.2044 34 21V24",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0004 23C34.0004 22.2044 34.3164 21.4413 34.879 20.8787C35.4417 20.3161 36.2047 20 37.0004 20C37.796 20 38.5591 20.3161 39.1217 20.8787C39.6843 21.4413 40.0004 22.2044 40.0004 23V32C40.0004 35.1826 38.7361 38.2348 36.4856 40.4853C34.2352 42.7357 31.183 44 28.0004 44H24.0004H24.4164C22.429 44.0003 20.4727 43.5071 18.7231 42.5646C16.9735 41.622 15.4854 40.2597 14.3924 38.6L14.0004 38C13.3764 37.042 11.1864 33.224 7.42837 26.544C7.04527 25.8631 6.94293 25.0595 7.14313 24.3043C7.34333 23.5491 7.83026 22.9018 8.50037 22.5C9.21412 22.0717 10.0505 21.8942 10.8767 21.9957C11.7029 22.0972 12.4714 22.4718 13.0604 23.06L16.0004 26",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08203 11.188C6.61687 10.0659 8.26603 9.10927 10.002 8.33398",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 6.91602C30.64 7.62402 33.116 8.72002 35.37 10.14",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7946_5010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/dragDrop.2c971edc.svg";
export { ForwardRef as ReactComponent };